jQuery(function ($) {
    $(document).ready(function () {

        $activeBlock = $('.account__addresses').hasClass('account-info__content-block--active');
        
        if ($activeBlock) {
            $('.account__addresses').css({'height': 'auto', 'overflow': 'unset'});
        } else {
            $('.account__addresses').css('overflow','hidden');
        }
        
        $('.account__orders').css('overflow','hidden');
        $('.account__addresses-nforms').css('overflow','hidden');
        $('.account__addresses-mforms').css('overflow','hidden');

        $('.active-progress-bar').on('click touched', function() {
            $(window).scrollTop(0);
            $("body").css("overflow","hidden");
            
            $('.modal-progress-bar').toggleClass('modal--opened');
            /*$('#progress-bar').progress_fnc({ type: 'start' });*/
        });

        $('.form-field-select').each(function () {
            $dataSelect = $(this).data('default');
            $selectId = $(this).attr('id');

            $('#'+$selectId + ' option').each(function () {
                if($(this).val() == $dataSelect) {
                    $(this).attr("selected",true);
                }
            });

        });

        $('.btn-progress-bar__exect').on('click touched', function(e) {

            $form = $(this).closest('form');

            $($form).submit(function() {
                $(window).scrollTop(0);
                $("body").css("overflow","hidden");

                $('.modal-progress-bar').toggleClass('modal--opened');
                /*$('#progress-bar').progress_fnc({ type: 'start' });*/
            });
        });

        var currentHash = $(location).attr('hash');

        if (currentHash == '#account__info') {
            $('.account__info').addClass('block-active');
            $('.account__orders').removeClass('block-active');
            $('.account__addresses').removeClass('block-active');
            $('.account__addresses-mforms').removeClass('block-active');
            $('.account__addresses-nforms').removeClass('block-active');

            $('.account-info__menu-link').each( function(){
                $(this).removeClass('is-active');
            });

            $(".account-info__menu-desktop").find("[data-block='account__info']").addClass('is-active');
        }

        if (currentHash == '#account__orders') {
            if ("(max-width: 450px)") {
                $('.account-info__content-block').each( function(){
                    $(this).removeClass('account-info__content-block--active');
                });

                $('.account__orders').css({'height': 'auto', 'overflow': 'unset'});
                $('.account__orders').addClass('account-info__content-block--active');
            }

            $('.account__info').removeClass('block-active');
            $('.account__orders').addClass('block-active');
            $('.account__addresses').removeClass('block-active');
            $('.account__addresses-mforms').removeClass('block-active');
            $('.account__addresses-nforms').removeClass('block-active');

            $('.account-info__menu-link').each( function(){
                $(this).removeClass('is-active');
            });

            $(".account-info__menu-desktop").find("[data-block='account__orders']").addClass('is-active');
        }

        if (currentHash == '#account__addresses') {
            if ("(max-width: 450px)") {
                $('.account-info__content-block').each( function(){
                    $(this).removeClass('account-info__content-block--active');
                });

                $('.account__addresses').css({'height': 'auto', 'overflow': 'unset'});
                $('.account__addresses').addClass('account-info__content-block--active');
            }

            $('.account__info').removeClass('block-active');
            $('.account__orders').removeClass('block-active');
            $('.account__addresses').addClass('block-active');
            $('.account__addresses-mforms').removeClass('block-active');
            $('.account__addresses-nforms').removeClass('block-active');

            $('.account-info__menu-link').each( function(){
                $(this).removeClass('is-active');
            });

            $(".account-info__menu-desktop").find("[data-block='account__addresses']").addClass('is-active');
        }


        $('.account-info__menu-link').click ( function(e) {

            var $activeClass = $(this).hasClass('is-active');

            if ( $activeClass == true ) {
                return;
            } else {
                $('.account-info__menu-link').each( function(){
                    $(this).removeClass('is-active');
                });

                $(this).addClass('is-active');

                $blockActive = $(this).data('block');

                $('.account__info').removeClass('block-active');
                $('.account__orders').removeClass('block-active');
                $('.account__addresses').removeClass('block-active');
                $('.account__addresses-mforms').removeClass('block-active');
                $('.account__addresses-nforms').removeClass('block-active');

                $('.'+$blockActive).addClass('block-active');
            }
        });

        $('.account__addresses--add').click ( function(e) {
            e.preventDefault();

            $('.account__addresses').removeClass('block-active');
            $('.account__addresses-mforms').removeClass('block-active');

            $('.account__addresses-nforms').addClass('block-active');

            $formActive = $(this).data('edit-address');

            $('.account-address-form ').each( function(){
                $(this).removeClass('visible');
            });

            $('[data-address-id="'+$formActive +'"]').addClass('visible');

        });

        $('.account__addresses-page--add').click ( function(e) {
            e.preventDefault();

            $('.account__addresses-page').removeClass('block-active');
            $('.account__addresses-page-mforms').removeClass('block-active');

            $('.account__addresses-page-nforms').addClass('block-active');

            $formActive = $(this).data('edit');

            $('.account-address-form ').each( function(){
                $(this).removeClass('visible');
            });

            $('[data-address-id="'+$formActive +'"]').addClass('visible');

        });

        $('.account__addresses-btn--edit').click ( function(e) {
            $(window).scrollTop(0);

            $('.account__addresses').removeClass('block-active');
            $('.account__addresses-nforms').removeClass('block-active');

            $('.account__addresses-mforms').addClass('block-active');

            $formActive = $(this).data('edit-address');

            $('.account-address-form ').each( function(){
                $(this).removeClass('visible');
            });

            $('[data-address-id="'+$formActive +'"]').addClass('visible');
        });

        $('.account__addresses-page-btn--edit').click ( function(e) {
            $(window).scrollTop(0);

            $('.account__addresses-page').removeClass('block-active');
            $('.account__addresses-page-nforms').removeClass('block-active');

            $('.account__addresses-page-mforms').addClass('block-active');

            $formActive = $(this).data('edit');

            $('.account-address-form ').each( function(){
                $(this).removeClass('visible');
            });

            $('[data-address-id="'+$formActive +'"]').addClass('visible');
        });

        $('.account__addresses--return').click ( function(e) {
            e.preventDefault();

            $('.account__addresses').addClass('block-active');

            $('.account__addresses-mforms').removeClass('block-active');
            $('.account__addresses-nforms').removeClass('block-active');
        });

        $('.account__addresses--return-btn').click ( function(e) {
            e.preventDefault();

            $('.account__addresses').addClass('block-active');

            $('.account__addresses-mforms').removeClass('block-active');
            $('.account__addresses-nforms').removeClass('block-active');
        });

        $('.account__addresses-page--return').click ( function(e) {
            e.preventDefault();

            $('.account__addresses-page').addClass('block-active');

            $('.account__addresses-page-mforms').removeClass('block-active');
            $('.account__addresses-page-nforms').removeClass('block-active');
        });

        $('.account__addresses-page--return-btn').click ( function(e) {
            e.preventDefault();

            $('.account__addresses-page').addClass('block-active');

            $('.account__addresses-page-mforms').removeClass('block-active');
            $('.account__addresses-page-nforms').removeClass('block-active');
        });

        $('.account__info-orders--all').click ( function(e) {
            e.preventDefault();
            $(window).scrollTop(0);

            $('.account__info').removeClass('block-active');
            $('.account__addresses').removeClass('block-active');
            $('.account__orders').addClass('block-active');
            $('.account__addresses-mforms').removeClass('block-active');
            $('.account__addresses-nforms').removeClass('block-active');

            $('.account-info__menu-link').each( function(){
                $(this).removeClass('is-active');
            });

            $(".account-info__menu-desktop").find("[data-block='account__orders']").addClass('is-active');
        });

        $('.account__info-address--all').click ( function(e) {
            e.preventDefault();
            $(window).scrollTop(0);
            
            $('.account__info').removeClass('block-active');            
            $('.account__orders').removeClass('block-active');
            $('.account__addresses').addClass('block-active');
            $('.account__addresses-mforms').removeClass('block-active');
            $('.account__addresses-nforms').removeClass('block-active');

            $('.account-info__menu-link').each( function(){
                $(this).removeClass('is-active');
            });

            $(".account-info__menu-desktop").find("[data-block='account__addresses']").addClass('is-active');
        });

        $('.account__info-address--edit').click ( function(e) {

            $('.account__info').removeClass('block-active');            
            $('.account__orders').removeClass('block-active');
            $('.account__addresses').removeClass('block-active');
            $('.account__addresses-mforms').addClass('block-active');
            $('.account__addresses-nforms').removeClass('block-active');

            $formmnActive = $(this).data('edit-address');

            $('.account-info__menu-link').each( function(){
                $(this).removeClass('is-active');
            });

            $(".account-info__menu-desktop").find("[data-block='account__addresses']").addClass('is-active');

            $('[data-address-id="'+ $formmnActive +'"]').addClass('visible');
        });

        $('.account__info-address--add').click ( function(e) {

            $('.account__info').removeClass('block-active');            
            $('.account__orders').removeClass('block-active');
            $('.account__addresses').removeClass('block-active');
            $('.account__addresses-mforms').removeClass('block-active');
            $('.account__addresses-nforms').addClass('block-active');

            $formmnActive = $(this).data('edit-address');

            $('.account-info__menu-link').each( function(){
                $(this).removeClass('is-active');
            });

            $(".account-info__menu-desktop").find("[data-block='account__addresses']").addClass('is-active');

            $('[data-address-id="'+ $formmnActive +'"]').addClass('visible');
        });

        $('.account__mmenu-option-link').click ( function(e) {

            $('.account-info__content-block').each( function(){
                $(this).removeClass('account-info__content-block--active');
            });

            $blockMActive = $(this).data('block');

            if ($blockMActive == 'account__addresses') {
                $('.account__addresses').css({'height': 'auto', 'overflow': 'unset'});
            }

            if ($blockMActive == 'account__orders') {
                $('.account__orders').css({'height': 'auto', 'overflow': 'unset'});
            }

            $('.'+$blockMActive).addClass('account-info__content-block--active');
        });

        $('.account__mnreturn').click ( function(e) {
            $('.account__addresses').css({'height': '0', 'overflow': 'hidden'});
            $('.account__orders').css({'height': '0', 'overflow': 'hidden'});
            $('.account__addresses-nforms').css({'height': '0', 'overflow': 'hidden'});
            $('.account__addresses-mforms').css({'height': '0', 'overflow': 'hidden'});

            $('.account-info__content-block').each( function(){
                $(this).removeClass('account-info__content-block--active');
            });
        });

        $('.account__addresses-mnbtn--edit').click ( function(e) {

            $('.account__addresses-mforms').css({'height': 'auto', 'overflow': 'unset'});
            $('.account__addresses-nforms').css({'height': '0', 'overflow': 'hidden'});
            $('.account__addresses').css({'height': '0', 'overflow': 'hidden'});
            $('.account__addresses-mforms').addClass('account-info__content-block--active');            

            $formmnActive = $(this).data('edit-address');

            $('.account-address-form ').each( function(){
                $(this).removeClass('visible');
            });

            $('[data-address-id="'+$formmnActive +'"]').addClass('visible');
        });

        $('.account__addresses-page-mnbtn--edit').click ( function(e) {

            $('.account__addresses-page-mforms').css({'height': 'auto', 'overflow': 'unset'});
            $('.account__addresses-page-nforms').css({'height': '0', 'overflow': 'hidden'});
            $('.account__addresses-page').css({'height': '0', 'overflow': 'hidden'});
            $('.account__addresses-page-mforms').addClass('account__addresses-block-mn--active');            

            $formmnActive = $(this).data('edit');

            $('.account-address-form ').each( function(){
                $(this).removeClass('visible');
            });

            $('[data-address-id="'+$formmnActive +'"]').addClass('visible');
        });

        $('.account__addresses--mnadd').click ( function(e) {

            $('.account__addresses-nforms').css({'height': 'auto', 'overflow': 'unset'});
            $('.account__addresses-mforms').css({'height': '0', 'overflow': 'hidden'});
            $('.account__addresses').css({'height': '0', 'overflow': 'hidden'});
            $('.account__addresses-nforms').addClass('account-info__content-block--active');


            $formmnActive = $(this).data('edit-address');

            $('.account-address-form ').each( function(){
                $(this).removeClass('visible');
            });

            $('[data-address-id="'+$formmnActive +'"]').addClass('visible');
        });

        $('.account__addresses-page--mnadd').click ( function(e) {

            $('.account__addresses-page-nforms').css({'height': 'auto', 'overflow': 'unset'});
            $('.account__addresses-page-mforms').css({'height': '0', 'overflow': 'hidden'});
            $('.account__addresses-page').css({'height': '0', 'overflow': 'hidden'});

            $('.account__addresses-page-nforms').addClass('account__addresses-block-mn--active');

            $formmnActive = $(this).data('edit');

            $('.account-address-form ').each( function(){
                $(this).removeClass('visible');
            });

            $('[data-address-id="'+$formmnActive +'"]').addClass('visible');
        });

        $('.account__addresses--mnreturn').click ( function(e) {

            $('.account__addresses-nforms').css({'height': '0', 'overflow': 'hidden'});
            $('.account__addresses-mforms').css({'height': '0', 'overflow': 'hidden'});
            $('.account__addresses-mforms').removeClass('account-info__content-block--active');
            $('.account__addresses-nforms').removeClass('account-info__content-block--active');
            $('.account__addresses').css({'height': 'auto', 'overflow': 'unset'});

        });

        $('.account__addresses--mnreturn-btn').click ( function(e) {

            $('.account__addresses').css({'height': 'auto', 'overflow': 'unset'});
            /*$('.account__addresses-nforms').css({'height': '0', 'overflow': 'hidden'});
            $('.account__addresses-mforms').css({'height': '0', 'overflow': 'hidden'});*/
            $('.account__addresses-mforms').removeClass('account-info__content-block--active');
            $('.account__addresses-nforms').removeClass('account-info__content-block--active');
            

        });

        $('.account__addresses-page--mnreturn').click ( function(e) {
            e.preventDefault();

            /*$('.account__addresses-page-nforms').css({'height': '0', 'overflow': 'hidden'});
            $('.account__addresses-page-mforms').css({'height': '0', 'overflow': 'hidden'});*/
            $('.account__addresses-page').css({'height': 'auto', 'overflow': 'unset'});
            $('.account__addresses-page-mforms').removeClass('account__addresses-block-mn--active');
            $('.account__addresses-page-nforms').removeClass('account__addresses-block-mn--active');            
        });

        $('.account__addresses-page--mnreturn-btn').click ( function(e) {
            e.preventDefault();

            /*$('.account__addresses-page-nforms').css({'height': '0', 'overflow': 'hidden'});
            $('.account__addresses-page-mforms').css({'height': '0', 'overflow': 'hidden'});*/
            $('.account__addresses-page').css({'height': 'auto', 'overflow': 'unset'});
            $('.account__addresses-page-mforms').removeClass('account__addresses-block-mn--active');
            $('.account__addresses-page-nforms').removeClass('account__addresses-block-mn--active');
        });

        $('.account__addresses--mnreturn-home').click ( function(e) {
            $('.account__addresses').css({'height': '0', 'overflow': 'hidden'});
            $('.account__orders').css({'height': '0', 'overflow': 'hidden'});
            $('.account__addresses-nforms').css({'height': '0', 'overflow': 'hidden'});
            $('.account__addresses-mforms').css({'height': '0', 'overflow': 'hidden'});

            $('.account-info__content-block').each( function(){
                $(this).removeClass('account-info__content-block--active');
            });

        });
    })
});

(function($) {

    $.fn.progress_fnc = function(options) {
      var settings = $.extend({
        type: 'start'
      }, options);
  
      var div = $(this);
      var progress = div.find('.cssProgress');
  
      progress.each(function() {
        var self = $(this);
        var progress_bar = self.find('.cssProgress-bar');
        var progress_label = self.find('.cssProgress-label, .cssProgress-label2');
        var progress_value = progress_bar.data('percent');
        var percentage = parseInt(progress_value, 10) + '%';
  
        progress_bar.css({'width': '0%', 'transition': 'none', '-webkit-transition': 'none', '-moz-transition': 'none'});
  
        if(settings.type == 'start') {
  
          progress_bar.animate({
            width: percentage
          }, {
            duration: 10000,
            step: function(x) {
              progress_label.text(Math.round(x) + '%');
            },
            complete: function() {
                $('.modal-progress-bar').removeClass('modal--opened');
            }
          });
  
        } else if(settings.type == 'reset') {
          progress_bar.css('width', '0%');
          progress_label.text('0%');
        }
  
      });
    }
  
  }(jQuery));

$(document).ready(function(){
  var loyalty_user = $('.loyalty-user').val();
  
  setTimeout(function(){$('.loyalty-submit').click();},5000);
  $('form.loyalty-ajax').submit(function(){
         $.ajax({
           headers: { "Accept": "application/json", "Access-Control-Allow-Origin:": "*"},
           url:"https://crm-latam.grandvision.com/fidelidad.aspx",
           method:"POST",
           dataType: 'json',
           crossDomain : true,
           beforeSend: function(xhr){xhr.withCredentials = true;},
           data: $('form.loyalty-ajax').serialize(),
           success: function(datos){
             $('.loyalty-loader').hide();
             // Respuesta al servicio
             console.log(datos); 
             
             var res_categoria = datos.categoria;
             var res_puntos = datos.puntos; res_puntos = parseInt(res_puntos);
             var res_vencimiento = datos.vencimiento;

             if (res_categoria != ""){
               if (res_categoria.indexOf("BLANCO") >= 0){$('<img class="img-category" style="max-width: 100%; height: auto;" src="https://cdn.shopify.com/s/files/1/0035/5991/5629/files/BLANCO.png?v=1630445395">').insertAfter('.benefit-label');}
               if (res_categoria.indexOf("BRONCE") >= 0){$('<img class="img-category" style="max-width: 100%; height: auto;" src="https://cdn.shopify.com/s/files/1/0035/5991/5629/files/BRONCE.png?v=1630445395">').insertAfter('.benefit-label');}
               if (res_categoria.indexOf("PLATA") >= 0){$('<img class="img-category" style="max-width: 100%; height: auto;" src="https://cdn.shopify.com/s/files/1/0035/5991/5629/files/PLATA.png?v=1630445396">').insertAfter('.benefit-label');}
               if (res_categoria.indexOf("ORO") >= 0){$('<img class="img-category" style="max-width: 100%; height: auto;" src="https://cdn.shopify.com/s/files/1/0035/5991/5629/files/ORO.png?v=1630445395">').insertAfter('.benefit-label');}
               if (res_categoria.indexOf("DIAMANTE") >= 0){$('<img class="img-category" style="max-width: 100%; height: auto;" src="https://cdn.shopify.com/s/files/1/0035/5991/5629/files/DIAMANTE.png?v=1630445395">').insertAfter('.benefit-label');}
             
               $('.val-puntos').text('Puntos: '+res_puntos);
               $('.val-vencimiento').text('Vencimiento: '+res_vencimiento);
               $('<form class="fetch-coupons" style="text-align: center;"><input type="text" name="email" value="'+loyalty_user+'" style="display: none;"><input type="submit" value="Ver cupones disponibles" style="padding: 5px 30px; background-color: #0055b8; color: #ffffff; border: 2px solid #0055b8; border-radius: 100px; cursor: pointer;"></form>').insertAfter('.img-category');
               
               $('form.fetch-coupons').submit(function(){
                 	 $('.coupon-loader').show();
                     $.ajax({
                       headers: { "Accept": "application/json", "Access-Control-Allow-Origin:": "*"},
                       url:"https://crm-latam.grandvision.com/fidelidad2.aspx",
                       method:"POST",
                       dataType: 'json',
                       crossDomain : true,
                       beforeSend: function(xhr){xhr.withCredentials = true;},
                       data: $('form.fetch-coupons').serialize(),
                       success: function(datos){
                         $(this).hide();
                         $('.coupon-loader').hide();
                         // Respuesta al servicio
                         console.log(datos); 
                         var cupon_accesorio = datos.CUPON_ACCESORIO;
                         var cupon_descuento = datos.CUPON_DSCTO;
                         var cupon_sol = datos.CUPON_SOLAR;
                         
                         var cupon_accesorio_uti = datos.CUPON_ACCESORIO_UTI;
                         var cupon_descuento_uti = datos.CUPON_DSCTO_UTI;
                         var cupon_sol_uti = datos.CUPON_SOLAR_UTI;
                         
                         if(cupon_accesorio_uti == 1){var cupon_accesorio_uti_text = '(Cupón Utilizado)';}else{var cupon_accesorio_uti_text = '';}
                         if(cupon_descuento_uti == 1){var cupon_descuento_uti_text = '(Cupón Utilizado)';}else{var cupon_descuento_uti_text = '';}
                         if(cupon_sol_uti == 1){var cupon_sol_uti_text = '(Cupón Utilizado)';}else{var cupon_sol_uti_text = '';}
                         
                         $('form.fetch-coupons').hide();
                         if (cupon_accesorio != ''){$('.box-cupones').show(); $('.cupon-accesorio').text('Cupon para accesorios: '+cupon_accesorio+' '+cupon_accesorio_uti_text);}
                         if (cupon_descuento != ''){$('.box-cupones').show(); $('.cupon-descuento').text('Cupon para descuentos en general: '+cupon_descuento+' '+cupon_descuento_uti_text);}
                         if (cupon_sol != ''){$('.box-cupones').show(); $('.cupon-sol').text('Cupon para Lentes de Sol: '+cupon_sol+' '+cupon_sol_uti_text);}
                         if (cupon_accesorio == '' && cupon_descuento == '' && cupon_sol == '' ){$('.box-cupones').show(); $('.cupon-accesorio').text('No posee cupones disponibles.');}
                         
                         //console.log('acc: '+cupon_accesorio_uti+', desc: '+cupon_descuento_uti+', sol: '+cupon_sol_uti);
             
                      }//success

                     });//ajax
                     return false;
               });//submit
               
             }else{
               $('<p style="text-align: center;"><i>¿No estás inscrito a nuestro Programa de Lealtad? Conoce más <a href="https://masvision.mx/pages/programa-lealtad" target="_blank">aquí</a>.</i></p>').appendTo('.loyalty-content');
             }
	
          }//success

         });//ajax
         return false;
   });//submit
  
  
  
  
});